import { makeAutoObservable } from "mobx";
import { PatientTableFilters, RxTableFilters } from "../../api-client";

export const PAGE_SIZE = 50;

interface PatientNavTableParams {
  patientTableFilters: PatientTableFilters;
  // additional parameter objects can be added here
  // in the case that we use multiple endpoints per nav table
}

interface RxNavTableParams {
  rxTableFilters: RxTableFilters;
  incomingRxId?: string;
  patientLastName?: string;
  // additional parameter objects can be added here
  // in the case that we use multiple endpoints per nav table
}

export default class NavTablesStore {
  public constructor() {
    makeAutoObservable(this);
  }

  // ********************************************* P A T I EN T   N A V   T A B L E S ******************
  // Patient navigation table query parameters

  public patientNavTableSelectedIndex: number = -1;
  public patientNavTableIsOpen: boolean = false;
  public patientNavTableParams: PatientNavTableParams = {
    patientTableFilters: {
      limit: PAGE_SIZE,
      location: undefined,
      lastName: "",
      includeDeleted: false,
      sortBy: { patientName: "ASC" },
    },
  };

  setPatientTableFilters = (
    params:
      | Partial<PatientTableFilters>
      | ((params: PatientTableFilters) => Partial<PatientTableFilters>)
  ): void => {
    const newParams =
      typeof params === "function"
        ? params(this.patientNavTableParams.patientTableFilters)
        : params;
    this.patientNavTableParams.patientTableFilters = {
      ...this.patientNavTableParams.patientTableFilters,
      ...newParams,
    };
  };

  setPatientNavTableIsOpen = (isOpen: boolean) => {
    this.patientNavTableIsOpen = isOpen;
  };

  setPatientNavTableSelectedIndex = (index: number | ((prevIndex: number) => number)) => {
    this.patientNavTableSelectedIndex =
      typeof index === "function" ? index(this.patientNavTableSelectedIndex) : index;
  };

  // Reset methods
  resetPatientNavTable = () => {
    this.patientNavTableSelectedIndex = -1;
    this.patientNavTableParams.patientTableFilters = {
      limit: PAGE_SIZE,
      location: undefined,
      lastName: "",
      includeDeleted: false,
    };
  };

  // ********************************************* R x   N A V   T A B L E S ******************

  public rxNavTableParams: RxNavTableParams = {
    rxTableFilters: {
      limit: PAGE_SIZE,
      rxNumber: "",
      includeDeleted: false,
      sortBy: { patientName: "ASC" },
      location: undefined,
      processingStatus: undefined,
      doctorReportStatus: undefined,
      lastName: "",
    },
    incomingRxId: undefined,
    patientLastName: undefined,
  };

  public rxNavTableSelectedIndex: number = -1;
  public rxNavTableIsOpen: boolean = false;

  setRxNavTableIsOpen = (isOpen: boolean) => {
    this.rxNavTableIsOpen = isOpen;
  };

  setRxNavTableSelectedIndex = (index: number | ((prevIndex: number) => number)) => {
    this.rxNavTableSelectedIndex =
      typeof index === "function" ? index(this.rxNavTableSelectedIndex) : index;
  };

  setIncomingRx = (id: string |undefined, lastName: string|undefined) => {
    this.rxNavTableParams.incomingRxId = id;
    this.rxNavTableParams.patientLastName = lastName;
    if (!!this.rxNavTableParams.rxTableFilters.lastName) this.rxNavTableParams.rxTableFilters.lastName = undefined; // clear anything that the used had typed as a filter
    this.setRxNavTableIsOpen(true);
  };

  setRxTableFilters = (
    params: Partial<RxTableFilters> | ((params: RxTableFilters) => Partial<RxTableFilters>), clearingIncomingRxId: boolean = true
  ): void => {
    const newParams =
      typeof params === "function" ? params(this.rxNavTableParams.rxTableFilters) : params;
    this.rxNavTableParams.rxTableFilters = {
      ...this.rxNavTableParams.rxTableFilters,
      ...newParams,
    };
    if (clearingIncomingRxId) {
      this.rxNavTableParams.incomingRxId = undefined;
      this.rxNavTableParams.patientLastName = undefined;
    }
  };
}
